import { ReactComponent as Logo } from '../../atoms/Icons/logo.svg'
import { NavItem } from '../../../theme/typography'
import HomeIcon from './homeIcon'
import DocumentIcon from './DocumentIcon'
import { ReactComponent as UserIcon } from './UserIcon.svg'
import * as S from './styled'
import { FunctionComponent } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { PageRoute } from '../../../navigation/constants'
import { SignOut } from '../Header/Header'

type OwnProps = {}

type Props = OwnProps

const NavBar: FunctionComponent<Props> = () => {
  const location = useLocation()

  return (
    <S.Container>
      <Logo width="50%" className="logo" />
      <S.NavUl>
        <S.NavLi>
          <NavLink to={PageRoute.START} exact className="link" activeClassName="active-link">
            <S.LinkHolder>
              <HomeIcon active={location.pathname === PageRoute.START} />
              <NavItem>Insikter</NavItem>
            </S.LinkHolder>
          </NavLink>
        </S.NavLi>
        <S.NavLi>
          <NavLink to={PageRoute.DOCUMENTS} className="link" activeClassName="active-link">
            <S.LinkHolder>
              <DocumentIcon active={location.pathname === PageRoute.DOCUMENTS} />
              <NavItem>Indata</NavItem>
            </S.LinkHolder>
          </NavLink>
        </S.NavLi>
        <S.NavLi>
          <NavLink to={PageRoute.ACCOUNT} className="link" activeClassName="active-link">
            <S.LinkHolder>
              <DocumentIcon active={location.pathname === PageRoute.ACCOUNT} />
              <NavItem>Konto</NavItem>
            </S.LinkHolder>
          </NavLink>
        </S.NavLi>
        <S.SignOut>
          <UserIcon />
          <NavItem>
            <SignOut />
          </NavItem>
        </S.SignOut>
      </S.NavUl>
    </S.Container>
  )
}

export default NavBar
